import {
    StandardEditResponseModel,
    StandardResponseModel,
} from "../pages/shared/models/standard-response-model";
import { BlogPostModel } from "../pages/shared/models/blogModel";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getPosts(
    filter?: any,
    limit?: number,
    page?: number,
): Promise<StandardResponseModel<BlogPostModel>> {
    try {
        const authorizationHeader = configAuthorizationHeader();

        return axiosInstance
            .get(
                `${API_URL}/blog?page=${page}&limit=${limit}`,
                { ...authorizationHeader },
            )
            .then((response) => {
                return response?.data as StandardResponseModel<BlogPostModel>;
            });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function getPostBySlug(slug: string) {
    try {
        const authorizationHeader = configAuthorizationHeader();
        return axiosInstance.get(
            `${API_URL}/blog/slug/${slug}`,
            authorizationHeader,
        );
    } catch (error) {
        console.error(error);
    }
}

async function createPost(
    formData: FormData,
): Promise<StandardResponseModel<BlogPostModel>> {
    try {
        const authorizationHeader = configAuthorizationHeader();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        authorizationHeader.headers["Content-Type"] = "multipart/form-data";
        return axiosInstance
            .post(
                `${API_URL}/blog`,
                formData,
                authorizationHeader,
            )
            .then((response) => {
                return response?.data as StandardResponseModel<BlogPostModel>;
            });
    } catch (error) {
        return Promise.reject(error);
    }
}

async function editPost(postId: number, updateData: FormData) {
    try {
        const authorizationHeader = configAuthorizationHeader();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        authorizationHeader.headers["Content-Type"] = "multipart/form-data";
        return axiosInstance
            .put(
                `${API_URL}/blog/${postId}`,
                updateData,
                authorizationHeader,
            )
            .then((response) => response?.data as StandardEditResponseModel);
    } catch (error) {
        console.error(error);

        return {
            acknowledged: false,
            matchedCount: 0,
            modifiedCount: 0,
            upsertedCount: 0,
            upsertedId: 0,
        };
    }
}

async function deletePostById(postId: number) {
    try {
        const authorizationHeader = configAuthorizationHeader();
        return axiosInstance.delete(
            `${API_URL}/blog/${postId}`,
            authorizationHeader,
        );
    } catch (error) {
        console.error(error);
    }
}

async function getImagePostById(imageId: number) {
    try {
        const authorizationHeader = configAuthorizationHeader();
        return axiosInstance.get(
            `${API_URL}/files/download/${imageId}`,
            authorizationHeader,
        );
    } catch (error) {
        console.error(error);
    }
}

function configAuthorizationHeader() {
    let token = localStorage.getItem("access_token");
    const refreshToken = localStorage.getItem("refresh_token");
    token = token ? token.replaceAll('"', "") : "";
    return {
        headers: {
            Authorization: "Bearer ".concat(token),
            "x-refresh-token": refreshToken,
        },
    };
}

export default {
    getPosts,
    getPostBySlug,
    createPost,
    editPost,
    deletePostById,
    getImagePostById
};
